/**
 * 从 localStorage 中获取值
 * @param key
 * @param initialValue
 * @returns
 */
export const getLocalValue = <T>(key: string, initialValue: T): T => {
  try {
    const item = window.localStorage.getItem(key);
    return item ? JSON.parse(item) : initialValue;
  } catch (error) {
    console.log(error);
    return initialValue;
  }
};

/**
 * 存储值到 localStorage 中
 * @param key
 * @param initialValue
 * @returns
 */
export const setLocalValue = <T>(key: string, value: T): void => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.log(error);
  }
};
